import {
  StreamlineIcon,
  type StreamlineIconProps,
} from '../streamlineIcon/StreamlineIcon';
import { SmileySmile2 as Svg } from './svgs/SmileySmile2.svg';

export const SmileySmile2 = (props: StreamlineIconProps) => (
  <StreamlineIcon {...props}>
    <Svg />
  </StreamlineIcon>
);
